var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-operations" },
    _vm._l(_vm.operations, function(operation, i) {
      return operation.visible(_vm.params.data)
        ? _c(
            "a",
            {
              key: i,
              class: "grid-operations-" + operation.type,
              on: {
                click: function(event) {
                  return operation.onClick(_vm.params.data, event)
                }
              }
            },
            [
              _vm._v(" " + _vm._s(operation.title) + " "),
              operation.showDropdownTriangle
                ? _c("span", [_vm._v("∨")])
                : _vm._e()
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }